export const capitalized = (word) => word.charAt(0).toUpperCase() + word.slice(1);
